import { useEffect, useRef, useState } from 'react'
import { useQueryClient } from 'react-query'
import { useSignalR } from '../signalR/SignalRProvider'
import { fetchTicketById }  from '../../data/signalRVerification/getTicketById'
import { fetchTicketNoteById }  from '../../data/signalRVerification/getTicketNoteById'
import { fetchTicketAttachmentById }  from '../../data/signalRVerification/getTicketAttachmentById'
import { useNotifications } from './notifications/NotificationsContext'

/**
 * Always-mounted component that listens to SignalR ticket messages and keeps
 * the react-query tickets cache up to date, even when TicketsTable is unmounted.
 * Must live inside both <SignalRProvider> and <QueryClientProvider>.
 */

const SignalRDataSync = () => {
    const queryClient = useQueryClient()
    const { message } = useSignalR() || {}
    const { addNotification } = useNotifications()

    useEffect(() => {
        const resolveSignalRNotification = async (payload) => {
            /*****************************************
            This is where we split apart the message, 
            resolve the entity and id and check that 
            it is one for the user and return back the
            object used to populate the notification with.
            *****************************************/
            console.log('resolveSignalRNotification payload:', payload)
        
            if (!payload) {
                return
            }
            // We could resolve the contact performing the action from the payload.PersonId here to be able to augment the message...
            // const currentCompany = getLocalStorage(process.env.REACT_APP_COMPANY_KEY)
            // const contacts = await fetchContacts()
            // const contact = contacts.Items.find(c => c.Id === payload.PersonId)
        
            // Create a new object for return and set the default return as not valid for this user in the company they are viewing and the sites that they have permissions to see
            var rtn = {}
            rtn.isValid = false
            // if (contact) {
            //     rtn.by = contact.firstName + ' ' + contact.lastName
            // }
            var entityTypeText = payload.entityType
            if (payload.entityType === "TicketNote") {
                entityTypeText = "Ticket Note"
            }
            if (payload.entityType === "TicketAttachment") {
                entityTypeText = "Ticket Attachment"
            }
            rtn.title = entityTypeText + ' ' + payload.action + 'd'
        
            // Check each entity to suss out how to verify it is for us and set up the return object
            if (payload.entityType === 'Ticket') {
                const ticket = await fetchTicketById(payload.entityId)
                console.log('ticket:', ticket)
                if (ticket.Items?.length > 0) {
                    rtn.isValid = true
                    rtn.ticketId = ticket.Items[0].id
                    if (payload.action === "Create") {
                        rtn.message = 'Ticket number: ' + ticket.Items[0].ticketNumber + ' has been created. '
                    } else if (payload.action === "Delete") {
                        rtn.message = 'Ticket number: ' + ticket.Items[0].ticketNumber + ' has been removed. '
                    } else if (payload.action === "Update") {
                        rtn.message = 'Ticket number: ' + ticket.Items[0].ticketNumber + ' has been updated. '
                    }    
                }
            } else if (payload.entityType === 'TicketNote') {
                const ticketNote = await fetchTicketNoteById(payload.entityId)
                if (ticketNote.Items?.length > 0) {
                    const ticket = await fetchTicketById(ticketNote.Items[0].ticketID)
                    if (ticket.Items?.length > 0) {
                        rtn.isValid = true
                        rtn.ticketId = ticket.Items[0].id
                        if (payload.action === "Create") {
                            rtn.message = 'Ticket number: ' + ticket.Items[0].ticketNumber + ' has a new note. '
                        } else if (payload.action === "Delete") {
                            rtn.message = 'Ticket number: ' + ticket.Items[0].ticketNumber + ' has a note removed. '
                        } else if (payload.action === "Update") {
                            rtn.message = 'Ticket number: ' + ticket.Items[0].ticketNumber + ' has a note updated. '
                        }                        
                    }
                }
            } else if (payload.entityType === 'TicketAttachment') {
                const tickeAttachment = await fetchTicketAttachmentById(payload.entityId)
                if (tickeAttachment.Items?.length > 0) {
                    const ticket = await fetchTicketById(tickeAttachment.Items[0].ticketID)
                    if (ticket.Items?.length > 0) {
                        rtn.isValid = true
                        rtn.ticketId = ticket.Items[0].id
                         if (payload.action === "Create") {
                            rtn.message = 'Ticket number: ' + ticket.Items[0].ticketNumber + ' has a new attachment. '
                        } else if (payload.action === "Delete") {
                            rtn.message = 'Ticket number: ' + ticket.Items[0].ticketNumber + ' has an attachment removed. '
                        }   
                    }
                }
            }
            if (rtn.isValid) {
                console.log("addNotification", rtn.title, rtn.message, rtn.ticketId, rtn.by)
                addNotification({title: rtn.title, message: rtn.message, ticketId: rtn.ticketId, person: rtn.by})
            }
        } 
        resolveSignalRNotification(message)

    }, [message, queryClient])

}

export default SignalRDataSync